import React from 'react';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { TextLink } from '../../../components/common/molecules/TextLink';
import { HorizonGreyLine } from '../../../components/common/atom/HorizonGreyLine';
import { HorizonLine } from '../../../components/common/molecules/HorizonLine';
import { EmptyMessage } from '../../../components/common/organism/EmptyMessage';
import OrderDetailShortForm from '../Detail/OrderDetailShortForm';

import * as PATH from '../../../lib/routes/path';
import TEXT from '../../../lib/text/textSalesBabyface.json';

const OrderListView = ({ data }) => {
  if (data.length <= 0)
    return (
      <EmptyMessage
        messageList={['아직 주문 내역이 없습니다. 아기를 만나러 가 볼까요?']}
        buttonPath={PATH.SALES}
        buttonTitle="신청하러 가기"
      />
    );

  return (
    <>
      {data.map((order) => (
        <Flex column alignItems="stretch" padding="0 0 1.25rem" key={order.id}>
          <Flex justifyContent="space-between">
            <Text size={12}>{order.createDateTime}</Text>
            <TextLink
              link={
                order.items[0].voucher
                  ? `${PATH.MYPAGE_VOUCHER_ORDER_DETAIL}/${order.id}`
                  : `${PATH.MYPAGE_ORDER_DETAIL}/${order.id}`
              }
              size={12}
            >
              상세보기 {'>'}
            </TextLink>
          </Flex>
          <OrderDetailShortForm key={order.id} order={order} />
          <HorizonGreyLine style={{ marginTop: '1.25rem' }} />
        </Flex>
      ))}
      {INFO.map((item) => (
        <Flex column alignItems="stretch" padding="1.25rem 0" key={item.title}>
          <HorizonLine text={item.title} />
          <Text size={12}>{item.content}</Text>
        </Flex>
      ))}
    </>
  );
};

export default OrderListView;

const INFO = [
  {
    title: TEXT.titleAnalyze,
    content: '결제완료 ☞ 1차 분석중 ☞ 2차 생성중 ☞ 생성완료 ☞ 발송완료',
  },
  {
    title: TEXT.titleRefund,
    content: (
      <>
        2차 생성중 단계부터는 환불 및 취소가 불가능 합니다.
        <br />
        <TextLink
          link={PATH.INFO_CANCEL}
          size={12}
          color="orangePink"
          weight="medium"
        >
          ☞ 규정 자세히 알아보기
        </TextLink>
      </>
    ),
  },
];
